/**
 * Wrapper components for MediaPicker with built-in data sources
 * These components combine MediaPicker with specific data source hooks for common use cases
 */

import {
  type UseModelArtworkDataSourceOptions,
  useModelArtworkDataSource,
} from './hooks'
import { MediaPicker, type MediaPickerProps } from './MediaPicker'

/**
 * Model Artwork Picker Wrapper
 * A wrapper for selecting artworks from a specific model
 */
export function ModelArtworkPicker<M extends boolean = false>(
  props: Omit<MediaPickerProps<M>, 'dataSource'> & {
    dataSourceOptions: UseModelArtworkDataSourceOptions
  },
) {
  const { dataSourceOptions, ...pickerProps } = props

  const dataSource = useModelArtworkDataSource(dataSourceOptions)

  return <MediaPicker {...pickerProps} dataSource={dataSource} />
}
